<template>
    <section  v-if="hasPermissions(['Utilities-Project-Codes-Mass-Add Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                The Mass Restore Bed Codes functionality allows you to quickly restore the bed codes for each room in your facility based on their global bed numbers and door numbers.
            </p>
        </div>

        <RoomAdvancedSearch
        class="mt-5"
        :show_sq_ft="false"
        ref="advanced_search"
        :checkeable="true"
        :rest_api="'rooms_advanced_search'"
        :rest_api_pagination="'rooms_advanced_search_pagination'"
        :table_headers="table_headers"
        @passInitialData="getInitialData($event)"
        />

        <div class="row py-0 d-flex justify-content-md-end">
            <div class="col-md-12">
                <button @click="restoreBedCodes()" class="mx-md-0 modal__buttons__item w-auto float-right px-3" v-html="'Restore Bed Codes'"/>
            </div>
        </div>
           
        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import RoomAdvancedSearch   from    '@/components/BuildingComponent/Rooms/AdvancedSearch/RoomAdvancedSearch'
import Resources from './resources'
import 'vuetify/dist/vuetify.min.css'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: 'MassBedCodes',

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        RoomAdvancedSearch
    },
    
    data() 
    {
        return {
            notyf,
            title_page:           'Mass Restore Bed Codes',
            title_room_tab:       'Rooms',
            rest_api:             `mass_bed_codes`,
            table_headers:        Resources.table_headers,
            breadcrumb:           Resources.breadcrumb,
            add_btn:              '',
            single_select:        false,
            table_selection:      [],
            search:               '',
            global_index:         '',
            single_object:        {},
            tasks:                [],
            array_options:        {},
            validate_data:        [],
            validation_table_headers: Resources.validation_table_headers
        }
    },


    methods: 
    {
        async restoreBedCodes()
        {
            let rooms_selected = this.$refs.advanced_search.returnedRoomsToParent()


            if(!rooms_selected.checked_items.length && !rooms_selected.select_all)
            {
                notyf.error('No rooms selected')
                return false
            }

            rooms_selected.checked_items    = rooms_selected.checked_items.map(item => item.origin_id)
            rooms_selected.unchecked_items  = rooms_selected.unchecked_items.map(item => item.origin_id)

            this.loader(true)

            const response = await this.post(this.rest_api, rooms_selected)

            this.loader()

            if(response.status)
            {
                this.notyfMesg('Bed Codes have been restored')
            }
            else
            {
                this.error_handling(response)
            }
            
        },

        fill_data(data)
        {
            console.log(data)
        },
        async getInitialData(data)
        {
            this.fill_data(data)
        }

    },

}

</script>
